export default () => JSON.parse(localStorage.getItem('user'))